import { Component } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';

@Component({
  selector: 'app-email-verification-code',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './email-verification-code.component.html',
  styleUrl: './email-verification-code.component.scss'
})
export class EmailVerificationCodeComponent {

  emailVerificationCodeForm = new FormGroup({
    emailVerificationCode: new FormControl('')
  });


  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  onSubmit() {
    this.authenticationService
      .verifyEmail({
        emailVerificationCode: this.emailVerificationCodeForm.value.emailVerificationCode!
      })
      .subscribe(() => {
        this.router.navigate(['home']);
      });
  }
}
